export const ContainerEnumConditional = (props) => {
    const { children, enum: enum_, showIn = [], } = props;
    return showIn.includes(enum_)
        ? children
        : null;
};
